import kachaAppShare from './initAppShareInfo'

const wx = require('weixin-js-sdk')
const axios = require('axios')

let bodyForbidSlide = function () {
  document.body.className += ' body-forbid-slide'
  document.documentElement.className += ' body-forbid-slide'
}

let bodyAutoSlide = function () {
  document.body.className = document.body.className.replace(' body-forbid-slide', '')
  document.documentElement.className = document.documentElement.className.replace(' body-forbid-slide', '')
}

let getRatioOf375 = () => {
  let fontSize = parseFloat(document.documentElement.style.fontSize)
  return fontSize / 37.5
}

let getQueryString = function (name, url) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = null
  if (url) {
    let str = url.split('?')[1]
    r = str ? str.match(reg) : null
  } else {
    r = window.location.search.slice(1).match(reg)
  }
  if (r !== null) {
    return decodeURI(r[2])
  }
  return ''
}

let querySerialize = function (obj) {
  let arr = []
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      arr.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]))
    }
  }
  return arr.join('&')
}

let queryDeserialize = function (str) {
  str = str || window.location.href
  let queryArr = str.split('?')
  if (queryArr.length < 2) {
    return ''
  }
  queryArr = queryArr[1].split('#/')[0]
  queryArr = queryArr.split('&')
  let obj = {}
  for (let i = 0, len = queryArr.length; i < len; i++) {
    let queryItem = queryArr[i].split('=')
    let key = decodeURIComponent(queryItem[0])
    obj[key] = decodeURIComponent(queryItem[1])
  }
  return obj
}

let share = function (url, imgUrl, title, desc) {
  // app share 绑定
  kachaAppShare(location.href, imgUrl, title, desc)
  // wx share 绑定
  axios.get(url).then(res => {
    wx.config({
      debug: false,
      appId: res.data.appId,
      timestamp: res.data.timestamp,
      nonceStr: res.data.nonceStr,
      signature: res.data.signature,
      jsApiList: ['onMenuShareQQ', 'onMenuShareTimeline', 'onMenuShareAppMessage']
    })
    wx.ready(function () {
      wx.onMenuShareTimeline({
        title, // 分享标题
        desc, // 分享描述
        link: location.href, // 分享链接 https://activity.9kacha.com/SelWine/  `${location.protocol}//activity.9kacha.com/SelWine/`
        imgUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
        }
      })
      wx.onMenuShareAppMessage({ // 分享朋友
        title, // 分享标题
        desc, // 分享描述
        link: location.href, // 分享链接
        imgUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      })
      wx.onMenuShareQQ({
        title, // 分享标题
        desc, // 分享描述
        link: location.href,
        imgUrl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      })
    })
  })
}

let goToWineDetail = function (href, id, wineSign, year) {
  // 获取平台信息
  function platForm () {
    var a = window.navigator.userAgent.toLowerCase()
    var b = a.match(/(iphone|ipod|ipad|android|windows phone|blackberry|symbian|Windows Phone)/)
    if (b) {
      b = b.toString()
    }
    if (b) {
      if (b.indexOf('iphone') >= 0) {
        return 'iphone'
      } else if (b.indexOf('ipod') >= 0) {
        return 'ipod'
      } else if (b.indexOf('ipad') >= 0) {
        return 'ipad'
      } else if (b.indexOf('android') >= 0) {
        return 'android'
      } else if (b.indexOf('windows phone') >= 0) {
        return 'wp7'
      } else if (b.indexOf('symbian') >= 0) {
        return 'symbian'
      } else if (b.indexOf('blackberry') >= 0) {
        return 'blackberry'
      } else if (b.indexOf('Windows Phone') >= 0) {
        return 'wp7'
      } else {
        return 'unknow'
      }
    }
    return 'unknow'
  }

  let wineInfoStr = 'wineInfo|' + id + '|' + wineSign + (year ? '|' + year : '')
  let ua = window.navigator.userAgent.toLowerCase()
  let plat = platForm()
  if (ua.indexOf('kachabrowser') != -1) {
    // 如果在app里
    if (plat == 'iphone' || plat == 'ipod' || plat == 'ipad') {
      window.location.href = 'kachajsbridge://' + wineInfoStr
    } else {
      window.kacha.jsInvoke(wineInfoStr)
    }
  } else {
    window.location.href = href
  }
}

let getBrowserType = function () {
  let ua = window.navigator.userAgent.toLowerCase()
  let browserType = ''
  if (ua.indexOf('kachabrowser') > -1) {
    // 酒咔嚓APP
    browserType = 'kachabrowser'
  } else if (/micromessenger/i.test(ua)) {
    // 微信
    browserType = 'weixin'
  } else if (ua.indexOf('qq') > -1) {
    if (/nettype/i.test(ua)) {
      // QQ
      browserType = 'qq'
    } else {
      // QQ浏览器
      browserType = 'qqbrowser'
    }
  } else if (ua.indexOf('baidu') > -1) {
    // 百度应用
    browserType = 'baidu'
  } else if (ua.indexOf('sogou') > -1) {
    // 搜狗
    browserType = 'sogou'
  } else if (ua.indexOf('ucbrowser') > -1) {
    // UC浏览器
    browserType = 'ucbrowser'
  } else if (ua.indexOf('chrome') > -1) {
    // 谷歌浏览器
    browserType = 'chrome'
  } else if (ua.indexOf('opera') > -1) {
    browserType = 'opera'
  } else if (ua.indexOf('firefox') > -1) {
    browserType = 'firefox'
  } else if (ua.indexOf('safari') > -1) {
    browserType = 'safari'
  } else if (ua.indexOf('compatible') > -1 && ua.indexOf('msie') > -1) {
    browserType = 'ie'
  } else if (ua.indexOf('trident') > -1) {
    browserType = 'edge'
  } else {
    browserType = 'other'
  }
  return browserType
}

let timeFormat = function (fmt, d) {
  let date = d || new Date()
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds(), // 毫秒
    'D+': date.getDay() // 星期几
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

let isObj = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

let urlAddSource = function (str) {
  if (!str) return ''
  let hasSource = getQueryString('source', str)
  if (hasSource) return str
  let source = getQueryString('source') || getQueryString('source', document.referrer) || ''
  if (!source) return str
  let hasQuestionMask = /\?/.test(str)
  return hasQuestionMask ? `${str}&source=${source}` : `${str}?source=${source}`
}
let isIOS = function () {
  return /(iphone|ipad|ipod|ios)/i.test(window.navigator.userAgent.toLowerCase())
}
export default {
  bodyForbidSlide,
  bodyAutoSlide,
  getQueryString,
  querySerialize,
  queryDeserialize,
  share,
  goToWineDetail,
  getRatioOf375,
  getBrowserType,
  timeFormat,
  isObj,
  isIOS,
  urlAddSource
}



// WEBPACK FOOTER //
// ./src/utils/index.js